<template>
<div class="container container--narrow pdt-50 mgb-50">
	<div v-if="groupQuestionCount === 1">
			<question-tag
				:avgSolveTime="question.avgSolveTime"
				:correctRate="question.correctRate"
				:level="paperLevel"
			></question-tag>
				<div class="mgt-16 t-subtitle6 t-line-h-28 font-rn">
					<vue-mathjax v-if="question.useMathjax" :formula="question.contents.text"></vue-mathjax>
					<div v-else>
						{{ question.contents.text }}
					</div>
				</div>
					<div v-if="question && question.contents && question.contents.image" class="mgt-24">
						<img :src="question.contents.image" alt="" class="b-radius4 ">
				</div>
				<div class="mgt-24">
					<label :id="`answerEl${question.id}`"
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined" data-mdc-auto-init="MDCTextField">
							<span class="mdc-text-field__ripple"></span>
							<textarea
								@input="updateText" :value="text"
								:maxlength="question.essay.maxAmount" aria-labelledby="my-label-id" class="mdc-text-field__input t-body6 font-r pdl-15 pdr-24 pdb-32 t-line-h-26 l-spacing2" cols="10" rows="3" @keyup="essayAnswer">
							</textarea>
							<span id="label" class="mdc-floating-label text-area-label">{{$t('1257')}}</span>
							<span class="mdc-line-ripple"></span>
					</label>
					<div class="mdc-text-field-helper-line mgr--12">
						<div v-if="checkAnswerValidate() && text" class="t-helper t-color-bodyGrayA">
							{{$t('1261', {str: question.essay.minAmount})}}
						</div>
							<div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"> </div>
					</div>
				</div>
			</div>
			<div v-else>
					<div v-if="index === 0" class="mgt-16 t-body1 t-line-h-28 ">
						{{groupQuestionTitle}}
					</div>
					<div class="mgt-24">
						<div class="mdc-card pda-24 bg-documentGray position-relative">
							<question-tag
								class="mgb-16"
								:avgSolveTime="question.avgSolveTime"
								:correctRate="question.avgSolveTime"
								:level="paperLevel"
							></question-tag>
							<div class="t-subtitle6 font-rn t-line-h-26">
								<vue-mathjax v-if="question.useMathjax" :formula="question.contents.text"></vue-mathjax>
								<div v-else>
									{{ question.contents.text }}
								</div>
							</div>
							<div v-if="question && question.contents && question.contents.image" class="mgt-24">
									<img :src="question.contents.image" alt="" class="b-radius4">
							</div>
				<div class="mgt-24">
						<label
										:id="`answerEl${question.id}`"
										class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined" data-mdc-auto-init="MDCTextField">
										<span class="mdc-text-field__ripple"></span>
										<textarea
											@input="updateText" :value="text"
											:maxlength="question.essay.maxAmount" aria-labelledby="my-label-id" class="mdc-text-field__input t-body6 font-r  pdl-15  pdr-24 pdb-32 t-line-h-26 l-spacing2" cols="10" rows="3" @keyup="essayAnswer"></textarea>
										<span id="label" class="mdc-floating-label text-area-label">{{$t('1257')}}</span>
										<span class="mdc-line-ripple"></span>
						</label>
						<div class="mdc-text-field-helper-line mgr--12">
							<div v-if="checkAnswerValidate() && text" class="t-helper t-color-bodyGrayA">
											{{$t('1261', {str: question.essay.minAmount})}}
							</div>
										<div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"> </div>
						</div>
				</div>
						</div>
					</div>
				</div>
		<question-tip v-if="question.tip" :marginType="groupQuestionCount === 1 ? true :false"  :tip="question.tip"/>
	</div>
</template>

<script>
/**
 * 에세이 문항 컴포넌트(essay type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import {questionMixin} from '@/mixins/question.js'
export default {
	props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'currentQuestionCheckStatus', 'setedAnswer', 'paperLevel', 'index'],
	data() {
		return {
			text: '',
			isSolve: false,
			textField: null
			
		}
	},
	components: {
		'question-tag': QuestionTag,
		'question-tip': QuestionTip,
	},

	mixins: [questionMixin],

	mounted() {
		this.textField = new MDCTextField(document.querySelector(`#answerEl${this.question.id}`))
		this.text = this.setedAnswer.text
		this.isSolve = this.setedAnswer.isSolve
		this.solveTime = this.setedAnswer.solveTime || 0
		this.textField.value = this.text
		this.startTimer()
	},

	updated() {
		const textField = new MDCTextField(document.querySelector(`#answerEl${this.question.id}`))
		textField.value = this.text
	},

	watch: {
		// currentQuestionCheckStatus에 따라 타이머 동작(currentQuestionCheckStatus timer action)
		currentQuestionCheckStatus: function(value) {
			if (!value) {
				this.startTimer()
			} else {
				this.clearTimer()
			}
		}
	},

	methods: {
		essayAnswer() {
			this.setAnswer()
		},

		//답안 유효성 체크(validation check answer)
		checkAnswerValidate() {
			let tabooWordValidate = _.some(this.question.essay.tabooWordList, (word) => {
				return _.includes(this.text, word)
			})
			let lengthValidate = this.question.essay.minAmount > this.text.length ? true : false
			return tabooWordValidate || lengthValidate
		},

		//답안정보 설정 및 부모 컴포넌트에 전달(Answer information setting and delivery to parent component)
		setAnswer() {
			if (this.text && !this.checkAnswerValidate()) {
				this.isSolve = true
			} else {
				this.isSolve = false
			}

			this.currentQuestionCheckTrueFalse()
      this.checkIsChecked()
		},

		currentQuestionCheckTrueFalse() {
      this.$emit('checkCurrentQuestionStatus')
    },

    checkIsChecked() {
      let params = this.setParam()
      this.$emit('checkIsCheckeds',params)
      this.$emit('setAnswers', params)
    },

		// 파라미터 설정(set parameter)
		setParam() {
			let params = {
				questionId: this.question.id,
				text: this.text,
				selected: [],
				texts: [],
				startDate: this.startDate,
				solveTime: this.solveTime,
				isSolve: this.isSolve,
				groupId: this.question.groupId,
			}
			return params
		},

		// v-model 제거 후 @input으로 변경
		updateText(e) {
			this.text = e.target.value;
		}
	}
}
</script>
